import * as Sentry from "@sentry/react";
import { isTestEnvironmentRunning } from "sonobello.utilities.react";
import {
  ITelemetryClient,
  ITelemetryContext,
  ITelemetryRecord,
  LoggedSentryTelemetry,
  SentryTelemetryClient,
  TelemetryRecorder
} from "sonobello.utilities.react.telemetry";

import EnvironmentConfiguration from "../../types/EnvironmentConfiguration";
import { TelemetrySessionTags, TelemetryUserTags } from "../types/ITelemetryClient";

/** The telemetry instance that will track and log all telemetry messages for use by test assertions. */
const testingTelemetry = new TelemetryRecorder<TelemetryUserTags, TelemetrySessionTags>();

const TestingTelemetryClient: ITelemetryClient<TelemetrySessionTags> &
  ITelemetryRecord<TelemetryUserTags, TelemetrySessionTags> = testingTelemetry;

export { TestingTelemetryClient };

/** The telemetry instance used by the application.
 * @remarks will set the instance to {@link TestingTelemetryClient} if Cypress is running, a version which sends to
 * Sentry otherwise, and adds console.logging if env name is 'local'.
 */
const TelemetryClient: ITelemetryClient<TelemetrySessionTags> &
  ITelemetryContext<TelemetryUserTags, TelemetrySessionTags> = isTestEnvironmentRunning()
  ? testingTelemetry
  : EnvironmentConfiguration.name === "Local"
    ? new LoggedSentryTelemetry<TelemetryUserTags, TelemetrySessionTags>(Sentry)
    : new SentryTelemetryClient<TelemetryUserTags, TelemetrySessionTags>(Sentry);

export default TelemetryClient;
